import { render, staticRenderFns } from "./AddSubCategory.vue?vue&type=template&id=e237296a&"
import script from "./AddSubCategory.vue?vue&type=script&lang=js&"
export * from "./AddSubCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports